<template>
  <div>
    <div v-if="updating" @click.self="reset" class="fixed top-0 flex items-center right-0 z-4 bg-black-80 vh-100 w-100">
      <div class="bg-nord6 center br2 pa3-ns pa2 mw6 w-100 flex flex-column justify-between">
        <h3 class="f4">{{task.text}} <span class="ml3 pa2 bg-nord4 br2">{{niceTime(task.time(false))}}</span></h3>
        <div>
          <div class="flex flex-column mb2">
            <label class="f6 ttu b pt2" for="day">Day</label>
            <input class="ba b--nord0 bw1 pa2 nord0 br2 input-reset bg-nord6 " type="date" v-model="date" id="day" value="2018-07-22" :max="maxDate">
            <label class="f6 ttu b pt2" for="hours">Hours</label>
            <input type="number" class="ba b--nord0 bw1 pa2 input-reset bg-nord6 nord0 br2" id="hours" v-model="hours" min="0" placeholder="3">
            <label class="f6 ttu b pt2" for="minutes">Minutes</label>
            <input type="number" class="ba b--nord0 bw1 pa2 input-reset bg-nord6 nord0 br2" id="minutes" v-model="minutes" min="0" placeholder="30">
          </div>
          <div class="pv2">
            <input type="radio" id="adding" value="Adding" v-model="type">
            <label for="adding" class="ml2 mr3 f4">Adding</label>
            <input type="radio" id="removing" value="Removing" v-model="type">
            <label for="removing" class="ml2 f4">Removing</label>
          </div>
        </div>
        <div class="flex justify-between mt3">
          <button 
            class="bg-nord14 pa2 bn br2 ttu b grow nord6" 
            :disabled="invalid" 
            :class="{'o-70': invalid}"
            @click="updateTime">{{type == "Adding" ? "Add" : "Remove"}} Time</button>
          <button class="bg-nord11 ttu b pa2 bn br2 grow nord6" @click="reset">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {niceTime} from "../util/format.js"
Date.prototype.toDateInputValue = (function() {
  var local = new Date(this);
  local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
  return local.toJSON().slice(0,10);
});
function parseDate(s) {
  var b = s.split(/\D/);
  return new Date(b[0], --b[1], b[2]);
}
export default {
  data: function(){
    return {
      type: "Adding", 
      updating: false,
      date: new Date().toDateInputValue(),
      hours: 0,
      minutes: 0,
      maxDate: new Date().toDateInputValue(),
      task: null,
    }
  },
  mounted(){
    this.$root.$on('modify', task => {
      this.task = task
      this.updating = true
    })
  },
  computed: {
    invalid(){
      var seconds = 60 * this.minutes + 3600 * this.hours
      if(this.type == "Removing") {
        seconds *= -1
      }
      return this.task.time(false) + seconds < 0 
    }
  },
  methods: {
    updateTime(){
      var date = parseDate(this.date)
      var seconds = 60 * this.minutes + 3600 * this.hours
      if(this.type == "Removing") seconds *= -1
      this.$root.$emit(this.task.id.toString(), seconds, date)
      this.reset()
    },
    niceTime: niceTime,
    reset(){
      Object.assign(this.$data, this.$options.data.apply(this))
    }
  }
}
</script>
